import React from "react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Gift, Package, Plane, Hotel } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

const tabConfig = [
  {
    value: "gift-cards",
    label: "Gift Cards",
    icon: <Gift className="h-4 w-4" />,
    to: "/rewardpoint/products",
    match: /^\/rewardpoint\/products(\/)?$/,
  },
  {
    value: "merchandise",
    label: "Merchandise",
    icon: <Package className="h-4 w-4" />,
    to: "/rewardpoint/products/merchandise",
    match: /merchandise/,
  },
  {
    value: "flight-booking",
    label: "Flight Booking",
    icon: <Plane className="h-4 w-4" />,
    to: "/rewardpoint/products/flight-booking",
    match: /flight-booking/,
  },
  {
    value: "hotel-booking",
    label: "Hotel Booking",
    icon: <Hotel className="h-4 w-4" />,
    to: "/rewardpoint/products/hotel-booking",
    match: /hotel-booking/,
  },
];

const ProductTabsNav: React.FC = () => {
  const location = useLocation();
  // Determine the active tab based on the current path
  const activeTab = tabConfig.find(tab => tab.match.test(location.pathname))?.value || "gift-cards";

  return (
    <div className="flex justify-start mb-6">
      <Tabs value={activeTab} defaultValue="gift-cards">
        <TabsList className="flex gap-2">
          {tabConfig.map(tab => (
            <TabsTrigger
              key={tab.value}
              value={tab.value}
              asChild={tab.value !== activeTab}
              className="flex items-center gap-2"
            >
              {tab.value === activeTab ? (
                <>
                  {tab.icon}
                  {tab.label}
                </>
              ) : (
                <Link to={tab.to} className="flex items-center gap-2">
                  {tab.icon}
                  {tab.label}
                </Link>
              )}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
    </div>
  );
};

export default ProductTabsNav; 